import { c as _c } from "react/compiler-runtime";
function BarWrapper(t0) {
  const $ = _c(8);
  const {
    height,
    heightRelative,
    className
  } = t0;
  const t1 = `bg-accent relative flex w-4 flex-col items-end justify-end overflow-hidden rounded-sm ${className ?? ""}`;
  let t2;
  if ($[0] !== height) {
    t2 = {
      height
    };
    $[0] = height;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== heightRelative) {
    t3 = heightRelative && <div className="bg-border absolute top-0 flex h-full w-4 rounded-t-lg md:w-6 md:rounded-t-lg lg:w-7.5 xl:w-10" style={{
      height: heightRelative
    }} />;
    $[2] = heightRelative;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t1} style={t2}>{t3}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export { BarWrapper };